enum DisplayType {
  Draft = 1,
  Public = 2,
  Soon = 3,
  Registered = 4,
}

enum CourseType {
  inClass,
  online,
  ofline,
}

enum SortCourseBy {
  MostlyViewed,
  RecentlyAdded,
  SelectedByUsers,
  MostlySelled,
  RecentlyUpdated,
}

enum SortJobsBy {
  MostlyViewed,
  RecentlyAdded,
  Archive,
}

enum CooperationTypeBy {
  FullTime,
  HalfTime,
  Project,
}

export type RulesMain = {
  ids: any[];
  searchDto: {
    search: string;
    pageSize: number;
    pageNumber: number;
    fieldSearchs: [
      {
        fieldName: string;
        text: string;
      }
    ];
  };
};

export { CooperationTypeBy, CourseType, DisplayType, SortCourseBy, SortJobsBy };
